import React from 'react';
import Footer from '../components/Footer';
import { motion } from 'framer-motion';

const UniversityAdmission = () => {
  return (
    <>
      <div className='p-5 lg:p-12 bg-waves bg-cover lg:px-36 min-h-screen space-y-3 lg:grid grid-cols-1'>
        <div>
          <motion.div
            animate={{ x: 0 }}
            initial={{ x: -500 }}
            transition={{ delay: 0.1 }}
          >
            <h3 className='text-black mb-4 text-4xl font-bold lg:text-left md:text-center lg:pl-12'>
              University Admission
            </h3>
          </motion.div>
          <div className='lg:py-4 lg:pr-12'>
            <div className='bg-white p-6 rounded-lg shadow-lg text-left flex'>
              <p className='text-black sm:text-justify md:text-xl'>
                Our teachers all have a wealth of knowledge with university
                entrance requirements for the top tier universities in Canada,
                USA and Europe. Link & Learn can help students with all their
                university application needs including guidance with writing
                their university admission essays, long term guidance with
                developing their personal profile to suit the ever changing well
                rounded demands of university requirements, recommendations and
                support for building up a student’s extra-curricular portfolio,
                preparation and practice for admission interviews and thorough
                guidance through all aspects of a student’s university
                application process.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default UniversityAdmission;
